import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import HeroContainer from 'components/HeroContainer';
import Hero from 'components/Hero';
import { CHILDREN_PROP_TYPES } from 'propTypes/childrenPropTypes';

function BaseScreenHero({
  RootProps = {},
  HeroContainerProps = {},
  HeroProps = {},
  heroContent,
  children
}) {
  const { hasHeroImage = false } = HeroContainerProps;
  return (
    <Box {...RootProps}>
      <HeroContainer {...HeroContainerProps}>
        {hasHeroImage && <Hero {...HeroProps}>{heroContent}</Hero>}
      </HeroContainer>
      {children}
    </Box>
  );
}

BaseScreenHero.propTypes = {
  RootProps: PropTypes.object,
  HeroContainerProps: PropTypes.object,
  HeroProps: PropTypes.object,
  heroContent: CHILDREN_PROP_TYPES,
  children: CHILDREN_PROP_TYPES
};

export default BaseScreenHero;
